import * as React from "react";
const SvgZoomOut = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { x: 11.705, y: 11.705, width: 10.59, height: 7.59, rx: 1.295, stroke: "white", style: {
  stroke: "white",
  strokeOpacity: 1
}, strokeWidth: 1.41 }), /* @__PURE__ */ React.createElement("path", { d: "M20 12V7C20 5.34315 18.6569 4 17 4H5C3.34315 4 2 5.34315 2 7V15C2 16.6569 3.34315 18 5 18H12", stroke: "white", style: {
  stroke: "white",
  strokeOpacity: 1
}, strokeWidth: 1.41 }));
export default SvgZoomOut;
